import React from 'react'

const AccountRoute = () => {
  return <div />
}

export { AccountRoute }
